import { useTranslation } from 'react-i18next';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { toast } from '@valwin/facto/components';

import { disconnectInstagram } from '../api';
import { instagramQueries } from './queries';

export function useDisconnectInstagram(pharmacyId: string) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => disconnectInstagram(pharmacyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: instagramQueries.account(pharmacyId).queryKey,
      });
      toast.success(t('toast accountDisconnected'), {
        description: t('toast instagramAccountDisconnected description'),
      });
    },
    onError: () => {
      toast.error(t('toast error'), {
        description: t('toast instagramAccountDisconnecting error description'),
      });
    },
  });
}
